// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:50:20

export default {
  "id": "bus-driver-simulator-3d",
  "slug": "bus-driver-simulator-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6e2aebd907f74c908512fe41d9818c2f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6e2aebd907f74c908512fe41d9818c2f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bus Driver Simulator 3D",
      "description": "Bus Driver Simulator 3D is a bus simulator in which you will be able to drive different types of buses traveling around different parts of the world including Los Angeles, Berlin, Rome, Alaska and so on.\n\nEach scenario in Bus Driver Simulator 3D has special characteristics. So, for example, in Alaska you will be driving on snowy tundra, and other cars will not be very much, but on the city highway in Los Angeles the traffic will be more intense.",
      "instructions": "Management:\n\nOn mobile devices:\n\nUse the buttons on the phone screen.\n\nOn PCs:\n- W-A-S-D keys to control the bus;\n- Spacebar - handbrake;\n- C - change camera view;\n- G - horn;\n- Q - left turn signal;\n- E - right turn signal;\n- Esc - pause.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "bus",
        "car",
        "travel"
      ]
    },
    "zh-CN": {
      "title": "公交司机模拟器3D",
      "description": "巴士模拟器3D是一款巴士模拟游戏，你将能够驾驶不同类型的巴士，在全球各地不同的地区旅行，包括洛杉矶、柏林、罗马、阿拉斯加等地。\n\n巴士模拟器3D中的每个场景都有其特殊特点。例如，在阿拉斯加，你将驾驶在雪地苔原上，路上车辆不多；而在洛杉矶的城市高速公路上，交通将更为繁忙。",
      "instructions": "管理：\n\n在移动设备上：\n\n使用手机屏幕上的按钮。\n\n在PC上：\n- W-A-S-D键控制公交车；\n- 空格键 - 刹车；\n- C - 切换摄像头视角；\n- G - 响笛；\n- Q - 左转信号；\n- E - 右转信号；\n- Esc - 暂停。",
      "genres": [
        "模拟"
      ],
      "tags": [
        "公交车",
        "汽车",
        "旅行"
      ]
    },
    "zh-TW": {
      "title": "巴士駕駛模擬器3D",
      "description": "巴士駕駛模擬器3D是一款巴士模擬遊戲，您將能夠駕駛各種類型的巴士，穿梭於世界各地不同的地區，包括洛杉磯、柏林、羅馬、阿拉斯加等。\n\nBus Driver Simulator 3D中的每個場景都有特殊的特色。例如，在阿拉斯加，您將在雪地苔原上駕駛，其他車輛不會很多；但在洛杉磯的城市高速公路上，交通將會更加繁忙。",
      "instructions": "管理：\n\n在行動裝置上：\n\n使用手機屏幕上的按鈕。\n\n在個人電腦上：\n- W-A-S-D 鍵控制巴士；\n- 空格鍵 - 手煞車；\n- C - 切換相機視角；\n- G - 車鈴；\n- Q - 左轉指示燈；\n- E - 右轉指示燈；\n- Esc - 暫停。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "公車",
        "汽車",
        "旅行"
      ]
    },
    "zh-HK": {
      "title": "巴士駕駛模擬器 3D",
      "description": "巴士司機模擬器3D是一款巴士模擬遊戲，讓你可以駕駛各種類型的巴士，穿梭於世界各個角落，包括洛杉磯、柏林、羅馬、阿拉斯加等。\n\n巴士司機模擬器3D中的每個場景都有其特殊特徵。例如，在阿拉斯加，你將駕駛在雪地荒原上，其他車輛不會很多；但在洛杉磯的城市高速公路上，車流將會更加擁擠。",
      "instructions": "管理：\n\n在手提電話上：\n\n使用電話螢幕上的按鈕。\n\n在電腦上：\n- W-A-S-D 鍵控制巴士；\n- 空格鍵 - 手刹；\n- C - 切換相機視角；\n- G - 喇叭；\n- Q - 左轉燈號；\n- E - 右轉燈號；\n- Esc - 暂停。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "巴士",
        "車",
        "旅遊"
      ]
    },
    "ja": {
      "title": "バス・ドライバー・シミュレーター3D",
      "description": "バス・ドライバー・シミュレーター3Dは、ロサンゼルス、ベルリン、ローマ、アラスカなど、世界中の異なる場所を巡る様々なバスを運転できるバスシミュレーターです。\n\nBus Driver Simulator 3Dの各シナリオには特別な特徴があります。例えば、アラスカでは雪のトゥンドラを運転し、他の車両もあまり多くありませんが、ロサンゼルスの都市高速道路では交通がもっと混雑しています。",
      "instructions": "管理：\n\nモバイルデバイス上で：\n電話のボタンを使用してください。\n\nPC上で：\n- W-A-S-Dキーでバスを操作；\n- スペースバー - 手ブレーキ；\n- C - カメラビューチェンジ；\n- G - クラクション；\n- Q - 左折信号；\n- E - 右折信号；\n- Esc - 一時停止。",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "バス",
        "車",
        "旅行"
      ]
    },
    "ko": {
      "title": "버스 드라이버 시뮬레이터 3D",
      "description": "버스 드라이버 시뮬레이터 3D는 로스앤젤레스, 베를린, 로마, 알래스카 등 전 세계 여러 지역을 돌아다니는 다양한 유형의 버스를 운전할 수 있는 버스 시뮬레이터입니다.\n\n버스 드라이버 시뮬레이터 3D의 각 시나리오는 특별한 특징을 가지고 있습니다. 예를 들어, 알래스카에서는 눈 많은 툰드라를 달리며 다른 차량은 많지 않지만, 로스앤젤레스의 도시 고속도로에서는 교통이 더 치열합니다.",
      "instructions": "관리:\n\n모바일 기기에서:\n휴대폰 화면의 버튼을 사용하세요.\n\nPC에서:\n- W-A-S-D 키로 버스를 제어;\n- 공백키 - 핸드브레이크;\n- C - 카메라 뷰 변경;\n- G - 서리소리;\n- Q - 왼쪽 회전 신호;\n- E - 오른쪽 회전 신호;\n- Esc - 일시정지.",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "버스",
        "자동차",
        "여행"
      ]
    },
    "fr": {
      "title": "Simulateur de Conducteur d'Autobus 3D",
      "description": "Bus Driver Simulator 3D est un simulateur de bus où vous pourrez conduire différents types de bus en circulant dans différentes parties du monde, y compris Los Angeles, Berlin, Rome, l'Alaska, etc.\n\nChaque scénario dans Bus Driver Simulator 3D a des caractéristiques spéciales. Par exemple, en Alaska, vous conduirez sur une toundra enneigée, et les autres véhicules ne seront pas nombreux, mais sur l'autoroute urbaine de Los Angeles, la circulation sera plus intense.",
      "instructions": "Gestion :\n\nSur les appareils mobiles :\n\nUtilisez les boutons sur l'écran du téléphone.\n\nSur les PC :\n- Les touches W-A-S-D pour contrôler le bus ;\n- La barre d'espace - frein à main ;\n- C - changer de vue de caméra ;\n- G - klaxon ;\n- Q - clignotant gauche ;\n- E - clignotant droit ;\n- Échap - pause.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "bus",
        "voiture",
        "voyage"
      ]
    }
  }
};
